import { commitMutation, graphql } from 'react-relay';
import environment from 'api/environment';
import { GraphError } from 'types/general';
import { mutations_UpdateManagerMutationResponse } from './__generated__/mutations_UpdateManagerMutation.graphql';

const updateMutation = graphql`
  mutation mutations_UpdateManagerMutation(
    $uuid: UUID!
    $firstName: String
    $lastName: String
    $jobTitle: String
    $email: String
    $telephone: String
    $profileImageToken: String
  ) {
    updateManager(
      input: {
        uuid: $uuid
        firstName: $firstName
        lastName: $lastName
        email: $email
        jobTitle: $jobTitle
        telephone: $telephone
        profileImageToken: $profileImageToken
      }
    ) {
      firstName
      lastName
      jobTitle
      email
      telephone
      profileImageUrl
    }
  }
`;

export const UpdateManager = (
  manager: {
    uuid: string;
    firstName: string;
    lastName: string;
    jobTitle: string;
    email: string;
    telephone: string;
    profileImageToken?: string;
  },
  errorCallback: (err: string) => void,
  successCallback: (response: mutations_UpdateManagerMutationResponse) => void
) => {
  const variables = {
    uuid: manager.uuid,
    firstName: manager.firstName,
    lastName: manager.lastName,
    jobTitle: manager.jobTitle,
    email: manager.email,
    telephone: manager.telephone,
    profileImageToken: manager.profileImageToken
  };

  commitMutation(environment, {
    mutation: updateMutation,
    variables,
    onCompleted: (
      response: mutations_UpdateManagerMutationResponse,
      errors: GraphError[]
    ) => {
      if (errors) {
        errorCallback(`${errors[0]?.extensions?.message}`);
        return;
      }
      successCallback(response);
    }
  });
};
